import { Col, Row } from 'react-bootstrap';
import { dateFormate } from '../../lib/constant';
import { UsersEntity } from '../../lib/types/UserManagement';

export default function UserDetails({ data }: { data: UsersEntity }) {
  console.log('UserDetails data:', data);
  return (
    <div className="py-4">
      <Row className="py-3">
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Name</p>
          <p
            className="fw-semibold"
            style={{
              wordBreak: 'break-word',
              overflow: 'break-word',
            }}
          >
            {data?.firstName && data?.firstName}{' '}
            {data?.lastName && data?.lastName}
            {!data?.firstName && !data?.lastName && '-'}
          </p>
        </Col>
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Employee ID</p>
          <p className="fw-semibold">{data?.employeeCode || '-'}</p>
        </Col>
        {/* <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Contact No.</p>
          <p className="fw-semibold">{data?.phone || '-'}</p>
        </Col> */}
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Email Id</p>
          <p className="fw-semibold">{data?.email}</p>
        </Col>
      </Row>
      <Row className="py-3">
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Wallet Address</p>
          <p className="fw-semibold">
            {data?.wallet?.[0]?.walletAddress || '-'}
          </p>
        </Col>
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Available Tokens</p>
          <p className="fw-semibold">{data?.balance}</p>
        </Col>
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Role</p>
          <p className="fw-semibold">{data?.role}</p>
        </Col>
      </Row>
      <Row className="py-3">
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Last Transaction</p>
          <p className="fw-semibold">{data?.lastTransaction}</p>
        </Col>
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Last Transaction Date</p>
          <p className="fw-semibold">
            {data?.lastTransactionDate && data?.lastTransactionDate !== ''
              ? dateFormate(data?.lastTransactionDate)
              : '-'}
          </p>
        </Col>
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Registered Date</p>
          <p className="fw-semibold">{dateFormate(data?.createdAt)}</p>
        </Col>
        <Col xs={12} md={4}>
          <p className="mb-1 text-grey">Organisation Name</p>
          <p className="fw-semibold">{data?.orgName?.name || '-'}</p>
        </Col>
      </Row>
      {/* <Row className="mt-4">
        <Col>
          <Button size="lg" variant="filled" className="btn-dark">
            Transfer Token
          </Button>
        </Col>
      </Row> */}
    </div>
  );
}
